import { render } from "./MainLayout.vue?vue&type=template&id=cafba5dc&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=cafba5dc&scoped=true&lang=css"
import "./MainLayout.vue?vue&type=style&index=1&id=cafba5dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cafba5dc"]])

export default __exports__